export default [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('./pages/DashboardPage.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'DashboardHome',
        component: () => import('./pages/HomePage.vue'),
      },
      {
        path: 'transactions',
        name: 'DashboardTransactions',
        component: () => import('./pages/TransactionsPage.vue'),
      },
      {
        path: 'subscriptions',
        name: 'DashboardSubscriptions',
        component: () => import('./pages/SubscriptionsPage.vue'),
      },
      {
        path: 'profile',
        name: 'DashboardProfile',
        component: () => import('./pages/ProfilePage.vue'),
      },
    ]
  }
];
